import {
  CLEAR_TRANSPORT_DATES,
  CLEAR_TRANSPORT_LOCATIONS,
  CLEAR_TRANSPORT_STOPS,
  GET_TRANSPORT_DATES_SUCCESS,
  GET_TRANSPORT_LOCATIONS_SUCCESS,
  GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS,
  GET_TRANSPORT_RETURN_STOPS_SUCCESS,
  GET_TRANSPORT_ROUTES_SUCCESS,
  GET_TRANSPORT_STOPS_SUCCESS,
  GET_TRANSPORT_TYPES_SUCCESS,
} from './types';

const initialState = {
  transportTypes: [],
  transportStops: {
    outboundStops: [],
    returnStops: [],
  },
  transportDates: [],
  transportLocations: [],
};

const transportReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_TRANSPORT_DATES:
      return {
        ...state,
        transportDates: [],
      };
    case CLEAR_TRANSPORT_LOCATIONS:
      return {
        ...state,
        transportLocations: [],
      };
    case CLEAR_TRANSPORT_STOPS:
      return {
        ...state,
        transportStops: {
          outboundStops: [],
          returnStops: [],
        },
      };
    case GET_TRANSPORT_DATES_SUCCESS:
      return {
        ...state,
        transportDates: action.payload.transportDates,
      };
    case GET_TRANSPORT_LOCATIONS_SUCCESS:
      return {
        ...state,
        transportLocations: action.payload.transportLocations,
      };
    case GET_TRANSPORT_STOPS_SUCCESS:
      return {
        ...state,
        transportStops: {
          outboundStops: action.payload.outboundStops,
          returnStops: action.payload.returnStops,
        },
      };
    case GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS:
      return {
        ...state,
        transportStops: {
          outboundStops: action.payload.outboundStops,
          returnStops: [],
        },
      };
    case GET_TRANSPORT_RETURN_STOPS_SUCCESS:
      return {
        ...state,
        transportStops: {
          outboundStops: [],
          returnStops: action.payload.returnStops,
        },
      };
    case GET_TRANSPORT_TYPES_SUCCESS:
      return {
        ...state,
        transportTypes: action.payload.transportTypes,
      };
    case GET_TRANSPORT_ROUTES_SUCCESS:
      return {
        ...state,
        transportRoutes: action.payload.transportRoutes,
      };
    default:
      return state;
  }
};

export default transportReducer;
